import { W as WuiSearchInput$1, d as defineCustomElement$1 } from './p-CIm_lpwO.js';

const WuiSearchInput = WuiSearchInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSearchInput, defineCustomElement };
